const incrementName = (name: string) => {
  let dashIndex = name.lastIndexOf('-')
  if (dashIndex >= 0) {
    const suffix = name.slice(dashIndex + 1)
    if (suffix.match(/^\d*$/)) {
      const count = parseInt(suffix)
      return `${name.slice(0, dashIndex)}-${count + 1}`
    }
  }
  return `${name}-1`
}

export function toUniqueProposedName(proposedName: string, existingNames: string[]) {
  const result = [...existingNames, proposedName]
  for (let i = 0; i < result.length; i++) {
    while (result.slice(0, i).filter((name) => name === result[i]).length > 0) {
      result[i] = incrementName(result[i])
    }
  }
  return result[result.length - 1]
}
